import React, { useRef } from 'react';
import { CardContainer, ContentWrapper, CTAButton, Description, Tag, TagsContainer, TagWithIcon, Title } from './styles';

export interface CardProps {
    title: string;
    tags: Array<{ label: string; icon?: React.ReactNode, color?: string; backgroundColor?: string }>;
    description: string;
    onCtaClick?: () => void;
    link: string
}

const Card: React.FC<CardProps> = ({ title, tags, description, onCtaClick, link }) => {
    const cardRef = useRef<HTMLDivElement>(null);

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!cardRef.current) return;
        const rect = cardRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        cardRef.current.style.setProperty('--mouse-x', `${x}px`);
        cardRef.current.style.setProperty('--mouse-y', `${y}px`);
    };

    return (
        <CardContainer
            ref={cardRef}
            onMouseMove={handleMouseMove}
        >
            <ContentWrapper>
                <Title>{title}</Title>
                <TagsContainer>
                    {tags.map((tag, idx) => (
                        <Tag key={idx}>
                            {tag.icon && <TagWithIcon color={tag.color} backgroundColor={tag.backgroundColor}>{tag.icon}</TagWithIcon>}
                            <label>{tag.label}</label>
                        </Tag>
                    ))}
                </TagsContainer>

                <Description>
                    {description}
                </Description>

                <CTAButton onClick={onCtaClick} href={link} target="_blank" rel="noopener noreferrer">
                    Try it now <span className="arrow">→</span>
                </CTAButton>
            </ContentWrapper>
        </CardContainer>
    );
};

export default Card;
